// Port of api/fuel/app/classes/filter/search/games/sorts/post/rating/user/changes.php
import F from 'offline/filter/constants'
import DB from 'offline/db'
import Util from 'offline/util'
import { sorted, sortReverse } from 'offline/filter/core/search/unit'

export default {
	name: 'post.sort.rating.user.changes',
	post: true,
	sorts: function() {
		return ['rating.revisions']
	},
	modifies: function() {
		return 'games'
	},
	require: function(config, filter) {
		return config.ownerType === F.OWNER_USER && sorted('rating.revisions', filter) > 0
	},
	run: function(config, filter, data, results) {
		if (!results.games || !results.games.length) return results
		var rows = DB.query('SELECT game_id, COUNT(log_id) as cnt FROM log_user_rating WHERE game_id IN(' + Util.in(results.games) + ') AND user_id = ' + config.userID + ' GROUP BY game_id')
		var counts = Util.associated(rows, 'game_id', 'cnt')
		var reverse = sortReverse('rating.revisions', filter)
		results.games.sort(function(a, b) {
			return reverse ? (parseInt(counts[b]||0)) - (parseInt(counts[a]||0)) : (parseInt(counts[a]||0)) - (parseInt(counts[b]||0))
		})
		var gameOrder = {}
		for (var i = 0; i < results.games.length; i++) gameOrder[results.games[i]] = i
		results.index.sort(function(a, b) {
			var ga = results.mapIndex ? results.mapIndex[a] : a
			var gb = results.mapIndex ? results.mapIndex[b] : b
			return (gameOrder[ga]||0) - (gameOrder[gb]||0)
		})
		return results
	}
}
